import React, { Component, PropTypes } from 'react';
import { TextField } from 'material-ui';
import { lensPath, set, curry } from 'ramda';

function validEmail(email) {
  const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
}

const setIn = curry((index, field, value, collection) => set(lensPath([index, field]), value, collection));

class ContactEdit extends Component {

  constructor() {
    super();
    this.state = {};
  }


  componentDidMount() {
    this._checkIfValidContact();
  }

  _validateField = (field) => {
    const fieldToSet = `${field}Validated`;
    const update = {};
    if (this.props.contact[field]) {
      if (this.props.contact[fieldToSet]) return;
      update[fieldToSet] = true;
    } else {
      if (this.props.contact[fieldToSet] || this.props.contact[fieldToSet] === undefined) {
        update[fieldToSet] = false;
      }
    }
    this.setState(update);
  };

  _updateValue = (field, event) => {
    const updateObj = setIn(this.props.index, field, event.target.value, this.props.contacts);
    const update = Object.keys(updateObj).map(k => updateObj[k]); //setIn converts the array to an object - so update has to convert back
    this.props.sendEditToReducer({ value: update });
    this._checkIfValidContact(update);
  };

  _checkIfValidContact = state => {
    const extendedState = Object.assign({}, this.props.contact, state || {});
    const isInvalid = !extendedState.type || !extendedState.firstName || !extendedState.lastName || !validEmail(extendedState.email) || !extendedState.phone;
    this.props.checkIfValidContact(isInvalid);
  };

  render() {
    const requiredContactTypes = {
      Administrator: true,
      Billing: true,
      Reservation: true,
      Sales: true,
    };
    const typeNode = (
      <TextField
        errorText={!this.props.contact.type && 'Required'}
        value={this.props.contact.type}
        floatingLabelText="Contact Type"
        disabled={requiredContactTypes[this.props.contact.type]}
        onChange={(e) => this._updateValue('type', e)}
        style={{ width: '100%' }}
      />
    );
    return (
      <div>
        <div className="profile-edit-contact">
          {typeNode}
          <TextField
            errorText={this.state.firstNameValidated !== undefined && !this.props.contact.firstName && 'Required'}
            value={this.props.contact.firstName}
            floatingLabelText="First Name"
            onBlur={() => this._validateField('firstName')}
            style={{ width: '100%' }}
            onChange={(e) => this._updateValue('firstName', e)}
          />
          <TextField
            errorText={this.state.lastNameValidated !== undefined && !this.props.contact.lastName && 'Required'}
            value={this.props.contact.lastName}
            floatingLabelText="Last Name"
            onBlur={() => this._validateField('lastName')}
            onChange={(e) => this._updateValue('lastName', e)}
            style={{ width: '100%' }}
          />
          <TextField
            errorText={this.state.emailValidated !== undefined && !validEmail(this.props.contact.email) && 'Required'}
            value={this.props.contact.email}
            floatingLabelText="Email"
            onBlur={() => this._validateField('email')}
            onChange={(e) => this._updateValue('email', e)}
            style={{ width: '100%' }}
          />
          <TextField
            errorText={this.state.phoneValidated !== undefined && !this.props.contact.phone && 'Required'}
            value={this.props.contact.phone}
            floatingLabelText="Phone"
            onBlur={() => this._validateField('phone')}
            onChange={(e) => this._updateValue('phone', e)}
            style={{ width: '100%' }}
          />
          <TextField
            value={this.props.contact.fax}
            floatingLabelText="Fax - Optional"
            onChange={(e) => this._updateValue('fax', e)}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    );
  }
}

ContactEdit.propTypes = {
  contact: PropTypes.object,
  checkIfValidContact: PropTypes.func,
  sendEditToReducer: PropTypes.func,
};

export default ContactEdit;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/company-contact-edit.jsx